<script>
export default {
    methods: {
        openInNewWindow(response) {
            let a = document.createElement('a');
            let filename;
            document.body.appendChild(a);
            a.style = "display: none";
            let contentType = response.headers.map['content-type'][0];
            let disposition = response.headers.map['content-disposition'][0];

            if (disposition && disposition.indexOf('attachment') !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            let blob = new Blob([response.data], {type: contentType});
            let url = URL.createObjectURL(blob);
            a.href = url;
            a.download = filename ? filename : this.config.index;
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        },
    }
};

</script>


// WEBPACK FOOTER //
// FileDownloader.vue?0d3bcff9